const TARGET_SIZE_BYTES = 200 * 1024 // 200 KB

/**
 * Compresses an image File to JPEG, scaling down if needed, targeting ~200KB.
 * @param file - Image file from an <input type="file">
 * @param maxWidth  - Max output width in px (aspect ratio preserved)
 * @param maxHeight - Max output height in px (aspect ratio preserved)
 */
export function compressImage(
  file: File,
  maxWidth = 1920,
  maxHeight = 1920
): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(new Error('Falha ao ler arquivo.'))
    reader.onload = () => {
      const img = new Image()
      img.onerror = () => reject(new Error('Falha ao carregar imagem.'))
      img.onload = () => {
        let w = img.naturalWidth
        let h = img.naturalHeight
        if (w > maxWidth || h > maxHeight) {
          const ratio = Math.min(maxWidth / w, maxHeight / h)
          w = Math.round(w * ratio)
          h = Math.round(h * ratio)
        }
        const canvas = document.createElement('canvas')
        canvas.width = w
        canvas.height = h
        const ctx = canvas.getContext('2d')
        if (!ctx) { reject(new Error('Canvas não suportado.')); return }
        ctx.drawImage(img, 0, 0, w, h)
        let quality = 0.88
        let result = canvas.toDataURL('image/jpeg', quality)
        while (result.length * 0.75 > TARGET_SIZE_BYTES && quality > 0.2) {
          quality -= 0.08
          result = canvas.toDataURL('image/jpeg', quality)
        }
        resolve(result)
      }
      img.src = reader.result as string
    }
    reader.readAsDataURL(file)
  })
}
